import LocalsearchLogo from './localsearch';
import LocalLogo from './local';
import LocalsearchLogoBlue from './localsearchblue';
import LocalsearchChristmasLogo from './localsearchChristmas';
import LocalChristmasLogo from './localChristmas';
import LocalsearchEasterLogo from './localsearchEaster';
import LocalEasterLogo from './localEaster';
import LocalsearchAnzacLogo from './localsearchAnzac';
import LocalAnzacLogo from './localAnzac';

export {
  LocalsearchLogo,
  LocalLogo,
  LocalsearchLogoBlue,
  LocalsearchChristmasLogo,
  LocalChristmasLogo,
  LocalEasterLogo,
  LocalsearchEasterLogo,
  LocalsearchAnzacLogo,
  LocalAnzacLogo,
};
